import styled from 'styled-components';

export const DrawerContents = styled.div<{scrollHeight: number}>`
  padding: ${({scrollHeight}) =>
      `max(0px, calc(var(--wb-drawer-top-padding) - ${scrollHeight}px))`}
    20px 20px 20px;
  width: 100%;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';
